import React from "react";
import { NavLink } from "react-router-dom";
import { getPrice } from '../../../utils'
import Imagen1 from "../../../images/dashboardAbogados/Imagen1.svg";
function IndexBoxOne({balance}) {
  return (
    <div className="saldo">
      <div className="inicio__box inicio__box-cuenta">
        <div className="inicio__box-cuenta-text">
          <h4>Cuentas con saldo</h4>
        </div>

        <div className="inicio__box-cuenta-cash">
          <p>{getPrice(balance, 'mxn', false, true)}</p>
        </div>
        <div className="image1">
          <img src={Imagen1} alt="Imagen2" />
        </div>
        <NavLink
          className="inicio__box-button"
          to="/lawyers/templates"
        >
          <p>Comienza a Ganar</p>
        </NavLink>
      </div>
    </div>
  );
}

export default IndexBoxOne;
